var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Box, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import BackDropComponent from "@/components/BackDrop";
import { getBulkWeightDiscrepancyCountRequest, getBulkWeightDiscrepancyDataRequest, getWeightDiscrepancyDataReset, } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import SearchIcon from "@mui/icons-material/Search";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import BulkDisputeComponent from "./BulkWeightDisputeDetails";
import DisputeFilterDrawer from "./DisputeFilterDrawer";
const BulkWeightDisputeDetails = () => {
    const [activeTab, setActiveTab] = React.useState("1");
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [selectedServicesP, setSelectedServicesP] = React.useState(null);
    const [orderNumbersStrP, setOrderNumbersStrP] = React.useState("");
    const [AWBstrP, setAWBstrP] = React.useState("");
    const [selectedCarriersP, setSelectedCarriersP] = React.useState(null);
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = React.useState(false);
    const [isFilterApplied, setIsFilterApplied] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10); // number of rows
    const [nextPage, setNextPage] = React.useState(0);
    const [weightDiscrepancy, setWeightDiscrepancy] = React.useState([]);
    const [totalCount, setTotalCount] = React.useState(0);
    const weightDiscrepancyState = useSelector((state) => state.getBulkWeightDiscrepancyDataReducer);
    const weightDiscrepancyCountState = useSelector((state) => state.getBulkWeightDiscrepancyCountReducer);
    const [isSearchActive, setIsSearchActive] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [inputValue, setInputValue] = React.useState("");
    const { tabStatus, orderId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tenantId, setTenantId] = React.useState(null);
    React.useEffect(() => {
        const updateTenantId = () => {
            const id = localStorage.getItem("tenantId");
            setTenantId(id);
        };
        updateTenantId(); // Get it on initial render
        window.addEventListener("tenantIdChanged", updateTenantId); // Listen for updates
        return () => {
            window.removeEventListener("tenantIdChanged", updateTenantId); // Clean up
        };
    }, []);
    React.useEffect(() => {
        setWeightDiscrepancy([]);
        setIsBackOpenOpen(true);
        dispatch(getWeightDiscrepancyDataReset());
        fetchWeightDiscrepancyData(rowsPerPage, 0);
        fetchWeightDiscrepancyCount();
    }, [tenantId]);
    const fetchWeightDiscrepancyData = (pageSize, pageNumber) => {
        const payload = {
            tenantId: tenantId,
            pageSize: pageSize,
            pageOffset: pageNumber ? pageNumber : 0,
        };
        setIsBackOpenOpen(true);
        dispatch(getBulkWeightDiscrepancyDataRequest(payload));
    };
    const fetchWeightDiscrepancyCount = () => {
        const payload = {
            tenantId: tenantId,
        };
        setIsBackOpenOpen(true);
        dispatch(getBulkWeightDiscrepancyCountRequest(payload));
    };
    const handleFilterOpen = () => {
        setIsFilterDrawerOpen(true);
    };
    const handleFilterClose = () => {
        setIsFilterDrawerOpen(false);
    };
    React.useEffect(() => {
        if (weightDiscrepancyCountState && !weightDiscrepancyCountState.loading) {
            setIsBackOpenOpen(false);
            setTotalCount(weightDiscrepancyCountState.Count || 0);
        }
        else if (weightDiscrepancyCountState.error) {
            setIsBackOpenOpen(false);
            if (weightDiscrepancyCountState.error instanceof Error) {
                enqueueSnackbar(weightDiscrepancyCountState.error.message, {
                    variant: "error",
                });
            }
        }
    }, [weightDiscrepancyCountState]);
    React.useEffect(() => {
        var _a, _b;
        if (weightDiscrepancyState && weightDiscrepancyState.data && !weightDiscrepancyState.loading) {
            console.log("weightDiscrepancyState dataaaaaa", (_a = weightDiscrepancyState.data) === null || _a === void 0 ? void 0 : _a.weightMismatchBatchInfoList);
            setIsBackOpenOpen(false);
            setWeightDiscrepancy(((_b = weightDiscrepancyState.data) === null || _b === void 0 ? void 0 : _b.weightMismatchBatchInfoList) || []);
        }
        else if (weightDiscrepancyState.error) {
            setIsBackOpenOpen(false);
            if (weightDiscrepancyState.error instanceof Error) {
                enqueueSnackbar(weightDiscrepancyState.error.message, {
                    variant: "error",
                });
            }
        }
    }, [weightDiscrepancyState]);
    const fetchByBatchId = (batchId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setIsSearchActive(true);
        try {
            const response = yield APIIN.get(`/report/weight/dispute/batch/search?weightDisputeBatchId=${batchId}`);
            console.log("response", response);
            if (response.weightMismatchBatchInfoList && Array.isArray(response.weightMismatchBatchInfoList)) {
                setWeightDiscrepancy(response.weightMismatchBatchInfoList);
                setTotalCount(response.weightMismatchBatchInfoList.length || 0);
            }
        }
        catch (error) {
            console.error("Error fetching batch", error);
            setWeightDiscrepancy([]);
            setTotalCount(0);
        }
        finally {
            setLoading(false);
        }
    });
    const debouncedSearch = _.debounce((val) => {
        if (val.length > 3) {
            fetchByBatchId(val);
        }
    }, 500);
    const handleChange = (e) => {
        const val = e.target.value;
        setInputValue(val);
        if (val.length > 3) {
            debouncedSearch(val);
        }
        else if (val.length === 0) {
            setIsSearchActive(false);
            fetchWeightDiscrepancyData(rowsPerPage, 0);
        }
    };
    return (React.createElement(Grid, { container: true, direction: "row", padding: 2, className: "m_background_color" },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { item: true, paddingBottom: 3, xs: 12 },
            React.createElement(Grid, { className: "m_background_color", style: { marginBottom: "20px", width: "100%" } },
                React.createElement(Grid, null,
                    React.createElement(Typography, { sx: {
                            fontFamily: "Poppins",
                            fontSize: "20px",
                            fontWeight: 600,
                            lineHeight: "30px",
                            textAlign: "left",
                            color: "#121114",
                        } }, "Batches"),
                    React.createElement(Typography, { sx: {
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "15px",
                            textAlign: "left",
                            color: "#5F5A6B",
                        } }, "Keep track of your batch creation progress effortlessly and download all your labels in one go.")),
                React.createElement(Grid, { className: "m_border_grey m_bg_wt", sx: { p: 1, mt: 1, ml: 0.2 }, item: true, xs: 12, container: true, direction: "row", alignItems: "center", justifyContent: "space-between", padding: 1, spacing: 1 },
                    React.createElement(Grid, { item: true, container: true, direction: "row", xs: 8 },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { fullWidth: true, size: "small", value: inputValue, onChange: handleChange, placeholder: "Search by batch number", InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(SearchIcon, { sx: { color: "#9e9e9e" } }))),
                                }, sx: {
                                    "& .MuiInputBase-root": {
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                    },
                                } })))),
                React.createElement(Box, { mt: 1 },
                    React.createElement(BulkDisputeComponent, { selectedCarriersP: selectedCarriersP, setSelectedCarriersP: setSelectedCarriersP, selectedServicesP: selectedServicesP, setSelectedServicesP: setSelectedServicesP, orderNumbersStrP: orderNumbersStrP, setOrderNumbersStrP: setOrderNumbersStrP, AWBstrP: AWBstrP, setAWBstrP: setAWBstrP, handleFilterOpen: handleFilterOpen, handleFilterClose: handleFilterClose, fetchWeightDiscrepancyData: fetchWeightDiscrepancyData, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, weightDiscrepancy: weightDiscrepancy, setWeightDiscrepancy: setWeightDiscrepancy, totalCount: totalCount, setTotalCount: setTotalCount, tabStatus: tabStatus, isFilterApplied: isFilterApplied, setIsFilterApplied: setIsFilterApplied, isSearchActive: !!inputValue })))),
        isFilterDrawerOpen && (React.createElement(DisputeFilterDrawer, { orderNumbersStrP: orderNumbersStrP, AWBstrP: AWBstrP, isFilterDrawerOpen: isFilterDrawerOpen, handleFilterClose: handleFilterClose, setOrderNumbersStrP: setOrderNumbersStrP, setAWBstrP: setAWBstrP, selectedCarriersP: selectedCarriersP, selectedServicesP: selectedServicesP, setSelectedCarriersP: setSelectedCarriersP, setSelectedServicesP: setSelectedServicesP }))));
};
export default BulkWeightDisputeDetails;
